import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  checkEmpty,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import PlTable from "../../Components/ReportTables/PlTable";
import { Constants } from "../../CommonMethhods/Constants";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import DurationChangeComponent from "./DurationChangeComponent";
import { Modal } from "react-bootstrap";
import SmallLoader from "../../Components/Common/smallLoader";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function PnlReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  // const userType = localStorage.getItem("userType").toLowerCase();
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase()
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [count, setCount] = useState();
  const [show, setShow] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [finalData, setFinalData] = useState([]);
  const [errorGrid, setErrorGrid] = useState(false);
  const [errorResp, setErrorResp] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [submitNameError, setSubmitNameError] = useState(false);
  const [page, setPage] = useState(1);
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [clientName, setClientName] = useState('')
  const [serverError, setServerError] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration, setSelectDuration] = useState("")
  const [scripData, setScripData] = useState([]);
  const [scripError, setScripError] = useState("");
  const [scripLoader, setScripLoader] = useState(false);
  const [scripExcelLoader, setScripExcelLoader] = useState(false);
  const [scripPdfLoader, setScripPdfLoader] = useState(false);
  const [selectedIsin, setSelectedIsin] = useState({
    isinVal: "", symbol: "", instType: "", optType: "", strikePrice: 0, expDate: ""
  });
  const [scripModal, setScripModal] = useState(false);
  const [expiryDates, setExpiryDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [scripNames, setScripNames] = useState([]);
  const [scripName, setScripName] = useState("");
  const [showDateName, setShowDateName] = useState(false);
  const [scriptDataSetTime, setScriptDataSetTime] = useState("")
  const clientInputRef = useRef(null);
  const [totalValues, setTotalValues] = useState({
    totalInvstmntAmt: 0,
    totalCurrentAmt: 0,
    totalRealizedPnl: 0,
    totalUnrealizedPnl: 0,
    totalPnl: 0,
  });
  const [symbolVal, setSymbolVal] = useState("");
  const [isinVal, setIsinVal] = useState("");
  const [reportVal, setReportVal] = useState("PNLRATE");



  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${current.getMonth() + 1
        }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  // useEffect(() => {
  //   debugger
  //   if (clientCode) {
  //     expirydatedropdown()
  //     scripnamedropdown()
  //   }else{
  //     console.log("no client");

  //   }

  // }, [clientCode])
  console.log(clientName, "clientName");

  useEffect(() => {
    if (clientInputRef.current.value && selectDuration && seg == "fo") {
      if (selectDuration == "custom") {
        setShowDateName(false)
        return
      } else {
        expirydatedropdown(clientName, fromDate, toDate);

      }
      console.log(selectDuration, "selectDuration");
    }
    else {
      setShowDateName(false)
    }
  }, [clientName, seg, selectDuration, fromDate, toDate]);

  const expirydatedropdown = async () => {
    console.log(clientName, "clientCode");
    setShowDateName(true)
    if (fromDate && toDate && clientName) {
      var data = {
        "clientCode": clientName,
        fromDate: fromDate,
        toDate: toDate,
      };
    }
    console.log(data, "data");
    setScriptDataSetTime("Data loading....")
    let encPayload = AESEncryption(data);
    try {
      const response = await axiosInstance.post(
        // 'https://uat-cosmos.bajajfinservsecurities.in/api/rm/Report/expirydatedropdown',
        // `${SERVICES.EDIT_APPLICATION}`,
        Dashboard_Client_Report.Expirydatedropdown,
        encPayload,

      );
      const data = await response.data;
      let editResponse = ApiResDecrypt(data);
      console.log(editResponse, "editResponse");
      if (editResponse.status == 0) {
        setScriptDataSetTime("---Select Expiry Date---")
        setExpiryDates(editResponse.data);
      } else {
        setExpiryDates([])
        setScriptDataSetTime("Expiry Date does not exist")
      }

      // setTimeout(() => {
      //   setExpiryDates(editResponse.data);
      // }, 500);

    } catch (err) {

    }
  }

  const scripnamedropdown = async (clientNum) => {
    let data = {
      "clientCode": clientNum
    };
    console.log(data, "data");
    let encPayload = AESEncryption(data);
    try {
      const response = await axiosInstance.post(
        // 'https://uat-cosmos.bajajfinservsecurities.in/api/rm/Report/scripnamedropdown',
        Dashboard_Client_Report.Scripnamedropdown,
        encPayload,

      );
      const data = await response.data;
      let editResponse = ApiResDecrypt(data);
      console.log(editResponse, "editResponse");
      setScripNames(editResponse.data || []);
    } catch (err) {

    }
  }
  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    const partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };

    const encPayload =
      userType === "partner" || partnerRoleNew === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        userType === "partner" || partnerRoleNew === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,
        userType === "partner" || partnerRoleNew === "partner" ? encPayload : `"${encPayload}"`,

      );

      const res =
        userType === "partner" || partnerRoleNew === "partner"
          ? JSON.parse(decryptData(getSearchDetail?.data))
          : ApiResDecrypt(getSearchDetail?.data);

      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
    } finally {
      setScrollLoader(false);
    }
  }
  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setNameError(false);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };
  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${mm}-${dd}-${yyyy}`;
  };

  //search api end
  const getPnlReport = async (fileType) => {
    // debugger
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");
    setSmallLoaderMail(fileType === "mail");
    setLoader(fileType === "grid");
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: seg,
      expiryDate: selectedDate ? formatToMMDDYYYY(selectedDate) : "",
      symbol: (seg === "fo" && scripName) || "",
      rate: seg === "stocks" ? reportVal : ""
    };
    console.log(payloadValue, "encPayload");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.PnlReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileType === "grid") {
          if (seg === "stocks") {
            console.log("res equity", res)
            setFinalData(res?.data?.pnlEqList);
            setTotalValues({
              totalInvstmntAmt: res?.data?.totalInvstmntAmt,
              totalCurrentAmt: res?.data?.totalCurrentAmt,
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          } else if (seg === "mf") {
            setFinalData(res?.data?.pnlMfList);
            setTotalValues({
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          } else {
            setFinalData(res?.data?.pnlFoList);
            setTotalValues({
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setFinalData([]);
        if (fileType !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const getScripData = async (type, isinVal, symbol, instType, optType, strikePrice, expDate) => {
    console.log(expDate, "expDate");

    setScripExcelLoader(type === "excel");
    setScripPdfLoader(type === "pdf");
    setScripLoader(type === "grid");

    const dateStr = expDate;
    const [day, month, year] = dateStr.split("-");
    const formattedDate = `${month}-${day}-${year}`;

    let payloadValue = {
      partyCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      isin: seg === "fo" ? "" : isinVal,
      fileType: type,
      segType: seg === "stocks" ? "eq" : seg === "fo" ? "fo" : "",
      secName: symbol,
      instType: instType,
      optType: optType,
      strikePrice: strikePrice,
      expiryDate: expDate?.length > 0 ? formattedDate : ""

    };

    console.log(payloadValue, "payloadValueScrip");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.PnlReportScripHistory,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      console.log(res, "resresres");

      if (res?.status === 0) {
        console.log(res?.data, "ApiResDecrypt");
        if (type === "grid") {
          setScripData(res?.data?.tradeSummary);
        } else if (type === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (type === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setScripData([]);
        // setSymbolVal("")
        // setIsinVal("")
        if (type !== "grid") {
          toast.error(res?.message)
        } else {
          setScripError(res?.message)
        }
      }
    } catch (error) {
      console.log(error);
      setScripError(error?.message)
      if (type !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setScripExcelLoader(false);
      setScripPdfLoader(false);
      setScripLoader(false);
    }
  };

  const handleScripModal = (type, isinVal, symbol, instType, optType, strikePrice, expDate) => {
    const isinData = {
      isinVal,
      symbol,
      instType,
      optType,
      strikePrice,
      expDate
    };

    getScripData(type, isinVal, symbol, instType, optType, strikePrice, expDate)
    setSelectedIsin(isinData)
    setScripModal(true);
  }

  const handleOnClick = (e) => {
    // debugger
    setShow(false);
    if (clientCode) {
      if (e.target.value) {
        if (selectDuration) {
          if (
            compareDate(fromDate) &&
            compareDate(toDate) &&
            checkDateRange(fromDate, toDate)
          ) {
            getPnlReport(e.target.value);
            setErrorResp(false);
            // setShowDateName(true)
          } else {
            setErrorResp("Please Select Correct Date");
          }
        }
        else {
          setErrorResp("Please Select Duration");
        }
      }
    } else {
      setSubmitNameError("Please Select Client Name/Code");
    }
  };

  const dateSetGetData = () => {
    if (clientCode) {
      if (selectDuration) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setErrorResp(false);
          // setShowDateName(true)
          expirydatedropdown(clientName, fromDate, toDate);
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }
      else {
        setErrorResp("Please Select Duration");
      }
    }

  }
  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setFinalData([]);
    setSeg(e.target.value);
    setErrorGrid(false);
  };

  const handleReportType =(e)=> {
    setFinalData([]);
    setReportVal(e?.target?.value);
    setErrorGrid(false);
  }

  console.log(seg, "seg");

  const handleFromDateChange = (e) => {
    setFinalData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    console.log(d, "datechange");

    // if (clientCode && toDate) {
    //   expirydatedropdown(clientCode, d, toDate);
    // }
    setFromDate(d);
    setErrorResp(false);
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setFinalData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    // if (clientCode && fromDate) {
    //   expirydatedropdown(clientCode, fromDate, d);
    // }
    setErrorResp(false);
    setServerError(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  console.log(scripData, "scripData");

  function formatDateValue(dateStr) {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr; // fallback if invalid
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const showModalActiveData = (scripData) => {
    return (
      seg === "stocks" ?
        (scripData &&
          scripData.map((info, key) => {
            // setSymbolVal(info?.scripName);
            // setIsinVal(info?.isin)
            return (
              <tr key={key}>
                <td>
                  {checkEmpty(info?.saudaDt) ? "-" : formatDateValue(info?.saudaDt)}
                </td>
                <td>{checkEmpty(info?.action) ? "-" : info?.action}</td>
                {/* <td>{checkEmpty(info?.scripName) ? "-" : info?.scripName}</td>

                <td>
                  {checkEmpty(info?.isin) ? "-" : info?.isin}
                </td> */}
                <td>
                  {checkEmpty(info?.txnProdType) ? "-" : info?.txnProdType}
                </td>
                <td>
                  {checkEmpty(info?.trdQty) ? "-" : info?.trdQty}
                </td>
                <td>
                  {checkEmpty(info?.pnlRate) ? "-" : info?.pnlRate}
                </td>
                <td>
                  {checkEmpty(info?.txnVal) ? "-" : info?.txnVal}
                </td>
                <td>
                  {checkEmpty(info?.rmrk) ? "-" : info?.rmrk}
                </td>
                <td>
                  {checkEmpty(info?.flag) ? "-" : info?.flag}
                </td>
              </tr>
            );
          })
        ) :
        (scripData &&
          scripData.map((info, key) => {
            return (
              <tr key={key}>
                <td>
                  {checkEmpty(info?.saudaDate) ? "-" : formatDateValue(info?.saudaDate)}
                </td>
                <td>{checkEmpty(info?.action) ? "-" : info?.action}</td>
                {/* <td>{checkEmpty(info?.scripName) ? "-" : info?.scripName}</td> */}

                <td>
                  {checkEmpty(info?.expiryDate) ? "-" : formatDateValue(info?.expiryDate)}
                </td>
                <td>
                  {checkEmpty(info?.exchange) ? "-" : info?.exchange}
                </td>
                <td>
                  {checkEmpty(info?.quantity) ? "-" : info?.quantity}
                </td>
                <td>
                  {checkEmpty(info?.price) ? "-" : info?.price}
                </td>
                <td>
                  {checkEmpty(info?.orderValue) ? "-" : info?.orderValue}
                </td>
              </tr>
            );
          })
        )
    );
  };

  const onChangeDuration = () => {
    // debugger
    // if (fromDate && toDate && clientCode) {
    //   expirydatedropdown()
    // } else {
    //   if (!clientCode) {
    //     // toast.error("Please Select Client Name/Code")
    //     setSubmitNameError("Please Select Client Name/Code");
    //   }
    //   else if (toDate && clientCode) {
    //     toast.error("Please Select Duration")
    //   }
    // }
    // setFinalData([]);
    // setErrorGrid(false);
    // setErrorResp(false);
    // setServerError(false);
    if (!clientCode) {
      // toast.error("Please Select Client Name/Code")
      setSubmitNameError("Please Select Client Name/Code");
    }

  }

  useEffect(() => {
    if (scripData && scripData?.length > 0) {
      setSymbolVal(scripData[0]?.scripName || "");
      setIsinVal(scripData[0]?.isin || "");
    }
  }, [scripData]);

  // const options = expiryDates.map(date => ({ value: date, label: date }));

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Pnl_Report}</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-2 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    ref={clientInputRef}
                    onChange={(e) => {
                      // debugger
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setErrorGrid(false);
                      setSubmitNameError(false);

                      // setShowDateName(false)
                      setExpiryDates([])
                      setScripNames([]);
                      setFinalData([])
                      if (e.target.value.length == 0) {
                        setClientName("")
                      }
                    }}

                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScroll(e)}
                      >
                        {clientList &&
                          clientList.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              onClick={() => {
                                setClientCode(item?.clientCode);
                                setClientName(item?.clientCode)
                                setShow(false);
                                // setShowDateName(true)
                                // console.log("Selected via ref:", clientInputRef.current.value);
                                // if (clientInputRef.current.value && fromDate && toDate) {
                                //   expirydatedropdown(clientName)
                                // }
                                console.log(item?.clientCode, "hsdfcgsc");
                                setExpiryDates([]);
                                setScripNames([]);
                                setSelectedDate("");
                                setScripName("");

                                if (item?.clientCode) {
                                  // expirydatedropdown(item?.clientCode)
                                  scripnamedropdown(item?.clientCode)
                                }

                              }}
                            >
                              {userType === "partner" || partnerRoleNew === "partner"? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                                :
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                            </li>
                          ))}
                        {scrollLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                        {nameError && !scrollLoader && (
                          <li
                            className="rm-maping-item-wrapper"
                            style={{
                              borderBottom: "none",
                              fontSize: "12px",
                            }}
                          >
                            {nameError}
                          </li>
                        )}
                      </ul>
                    </>
                  )}
                </div>
                {submitNameError && (
                  <span className="to-date-error" style={{ bottom: "-8px" }}>{submitNameError}</span>
                )}
              </div>
            </div>
            <div className="col-md-2 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Segment: </label>
                <select onChange={handleSegmentChange}>
                  <option value="stocks">{Constants.EQ}</option>
                  <option value="mf">{Constants.MF}</option>
                  <option value="fo">{Constants.FandO}</option>
                  <option value="curfo">{Constants.Currency}</option>
                  <option value="com">Commodity</option>
                  <option value="slbm">SLBM</option>
                </select>
              </div>
            </div>
            <div className="col-md-2 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div>
              {seg === "stocks" &&
              <div className="col-md-2 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Report Type: </label>
                  <select onChange={handleReportType}>
                    <option value="PNLRATE">PNL Rate</option>
                    <option value="NETRATE">Net Rate</option>
                  </select>
                </div>
              </div>
            }

            {customShow && <div className="col-md-3 col-sm-3 col-6 date-width">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}

            {customShow && <div className="col-md-3  col-sm-3 col-6 date-width">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />

            </div>}
            {(customShow && seg == "fo") && <div className="col-md-3  col-sm-3 col-6 date-fix-btn">
              <button className="set-date" onClick={() => dateSetGetData()}>Set Date</button>
            </div>}
            {showDateName &&
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Scrip Name</label>

                  <select
                    // className="input-st"
                    value={scripName}
                    onChange={(e) => setScripName(e.target.value)}
                  >
                    <option value="">-- Select Scrip --</option>
                    {scripNames.length > 0 ? <>
                      {scripNames.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </> : <option value="">Scrip Name does not exist</option>}

                  </select>
                </div>
              </div>}
            {showDateName &&
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Expiry Date </label>
                  <select
                    // className="input-st"
                    className="expiry-dropdown"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  >
                    {expiryDates.length > 0 ? <>
                      <option value="">{scriptDataSetTime}</option>
                      {expiryDates.map((date, index) => (
                        <option key={index} value={date}>
                          {date}
                        </option>
                      ))}</> :
                      <>
                        <option value="">{scriptDataSetTime}</option>
                      </>
                    }


                  </select>
                </div>
              </div>
            }

          </div>


          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
              disabled={loader}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            <ReportTableHeader
              smallLoaderMail={smallLoaderMail}
              showEmailBtn={true}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section pnl-wrapper">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : finalData && finalData.length > 0 ? (
              <div>
                <PlTable data={finalData} seg={seg} totalValues={totalValues} handleScripModal={handleScripModal} />
              </div>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : (
              errorGrid && noDataFound(errorGrid)
            )}
          </div>
        </div>
      </main >
      <Modal
        show={scripModal}
        onHide={() => setScripModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac header-pnl">
              <h2 className="h2-css-all">Trade Summary{" "}</h2>

              {scripLoader ?
                <div className="title-loader">
                  <SmallLoader />
                </div>
                :
                scripData && scripData?.length > 0 && (
                  <h4>
                    {seg === "stocks" ?
                      <> - {symbolVal} {isinVal && `(${isinVal})`}</>
                      : <> - {symbolVal}</>
                    }
                  </h4>
                )
              }

            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setScripModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {scripLoader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : scripData && scripData?.length > 0 ?
              <>
                <table className="table">
                  {seg === "stocks" ?
                    <thead>
                      <tr>
                        <th>{Constants.Date}</th>
                        <th>Type</th>
                        {/* <th>{Constants.Symbol}</th>
                        <th>{Constants.Isin}</th> */}
                        <th>{Constants.Exchange}</th>
                        <th>{Constants.Quantity}</th>
                        <th>Price</th>
                        <th>Order Value</th>
                        <th>Remark</th>
                        <th>Flag</th>
                      </tr>
                    </thead>
                    :

                    <thead>
                      <tr>
                        <th>{Constants.Date}</th>
                        <th>Type</th>
                        {/* <th>{Constants.Symbol}</th> */}
                        <th>Expiry Date</th>
                        <th>{Constants.Exchange}</th>
                        <th>{Constants.Quantity}</th>
                        <th>Price</th>
                        <th>Order Value</th>
                      </tr>
                    </thead>
                  }

                  <tbody>
                    {showModalActiveData(scripData)}
                  </tbody>
                </table>

                <div className="generate-btn-wrapper">
                  <button
                    className="generate-btn text-green"
                    value="excel"
                    onClick={() =>
                      handleScripModal(
                        "excel",
                        selectedIsin?.isinVal,
                        selectedIsin?.symbol,
                        selectedIsin?.instType,
                        selectedIsin?.optType,
                        selectedIsin?.strikePrice,
                        selectedIsin?.expDate
                      )
                    }
                  >
                    {scripExcelLoader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-excelsvg"></span>
                        {"Excel"}
                      </>
                    )}
                  </button>
                  <button
                    className="generate-btn txt-purple"
                    onClick={() =>
                      handleScripModal(
                        "pdf",
                        selectedIsin?.isinVal,
                        selectedIsin?.symbol,
                        selectedIsin?.instType,
                        selectedIsin?.optType,
                        selectedIsin?.strikePrice,
                        selectedIsin?.expDate
                      )
                    }
                    value="pdf"
                  >
                    {scripPdfLoader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-pdfsvg"></span> {"PDF"}
                      </>
                    )}
                  </button>
                </div>
              </>
              : scripError && noDataFound(scripError)
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PnlReportSidebar;
